export default "__VITE_ASSET__SeDoDpP4__"